import styled from "styled-components"
import { TxlLink, SimpleLink } from "./TxlLink"

const Menu = styled.div`
  padding-top: 10px;
  & ul {
    border-radius: 5px;
    background-color: ${props => props.theme.color.semiTranslucid};
    list-style: none;

    li {
      display: block;
      line-height: 60px;
      margin-left: 25px;
      border-bottom: 1px solid ${props => props.theme.color.border};

      ${TxlLink}, ${SimpleLink} {
        display: block;
        font-size: ${props => props.theme.font.size.menuitem};
      }
    }

    li:last-child {
      border-bottom: none;
    }
  }
`

export default Menu
